import React from 'react'

function XSvg() {
  return (
    <>
      <svg
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='16' cy='16' r='15.5' fill='white' stroke='#D1DEEE' />
        <path
          d='M13.0317 22.5008C19.0694 22.5008 22.3718 17.4986 22.3718 13.1607C22.3718 13.0186 22.3718 12.8772 22.3623 12.7363C23.0047 12.2716 23.5593 11.6963 24 11.0372C23.4009 11.3026 22.7653 11.4767 22.1146 11.5536C22.7997 11.1435 23.3128 10.4979 23.5577 9.73794C22.9134 10.1203 22.2084 10.3898 21.4733 10.5347C20.8526 9.87472 19.9857 9.5 19.0798 9.5C17.2772 9.5 15.794 10.9832 15.794 12.7857C15.794 13.0358 15.8225 13.2851 15.879 13.5287C13.241 13.3964 10.7797 12.1486 9.11359 10.0989C8.24722 11.5903 8.6955 13.5232 10.1299 14.481C9.60756 14.4655 9.09644 14.3246 8.64 14.0701V14.1117C8.64044 15.6684 9.74772 17.0214 11.2736 17.3296C10.7903 17.4614 10.2832 17.4807 9.79138 17.3859C10.2203 18.7198 11.4573 19.6393 12.8583 19.6656C11.6961 20.579 10.2596 21.0751 8.78144 21.0736C8.52025 21.0731 8.25931 21.0573 8 21.0262C9.50106 21.9895 11.2481 22.5006 13.0317 22.4983'
          fill='#0E1F33'
        />
      </svg>
    </>
  )
}

export default XSvg
